const fallbackSupportEmail = 'privacidade@salonflow.com.br';

export const publicSupportEmail =
    process.env.REACT_APP_SUPPORT_EMAIL?.trim() || fallbackSupportEmail;

export const dataDeletionEmailSubject = 'Solicitação de exclusão de dados - SalonFlow';

export const dataDeletionMailTo = `mailto:${publicSupportEmail}?subject=${encodeURIComponent(
    dataDeletionEmailSubject,
)}`;
